'use client';

// import { redirect } from 'next/navigation';
import { useSidebarStore } from '@/app/hooks/sidebarStore'
import { Check } from "lucide-react"
import { ShinyButton } from "./components/shiny-button";
import Link from "next/link"
import Categories from "./components/Categories";
import ProductList from "./components/products/ProductList";
import { MaxWidthWrapper } from './components/max-width-wrapper';
import { Heading } from './components/heading';
import PreSaveSection from "./components/PreSaveSection";
import Image from "next/image";

export default function Home() {

  // Redirecionamento redirect('/')
  // redirect('/landing');

  const { isCollapsed } = useSidebarStore()
  return (
    <main className={`max-w[1500px] mx-auto min-h-screen px-6 p-6 ml-0 transition-all duration-300 ${isCollapsed ? 'md:ml-16' : 'md:ml-64'}`}>
      <Categories />

      {/*<div className="mt-4 grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6">*/}
      <div className="mt-4 flex flex-col gap-6">
        <ProductList />
      </div>

      <MaxWidthWrapper className="mt-10">
        <div className="grid gap-8 md:grid-cols-[minmax(0,2fr)_minmax(0,3fr)] items-center rounded-2xl border border-zinc-800 bg-zinc-950/90 p-6 sm:p-8 shadow-xl">
          {/* Texto / CTA */}
          <div className="space-y-4">
          <span className="inline-flex items-center rounded-full bg-emerald-500/10 px-3 py-1 text-xs font-semibold text-emerald-400 ring-1 ring-emerald-500/30">
            Novo lançamento • Nightreggaex
          </span>

          <h2 className="text-2xl sm:text-3xl font-bold text-zinc-50">
            Reggae I Wanna — álbum completo - LIVE - 2026
          </h2>

          <p className="text-sm sm:text-base text-zinc-300 leading-relaxed">
            Baixe a versão Deluxe do álbum do NIGHTREGGAEX disponível apenas aqui no site!
          </p>

          <p className="text-lg font-semibold text-emerald-400">
            Apenas <span className="text-2xl">R$ 199,90</span>
          </p>
 
          <div className="flex flex-wrap items-center gap-3">
            <Link href="/album/reggae-i-wanna">
              <button className="inline-flex items-center justify-center rounded-full bg-emerald-500 px-5 py-2.5 text-sm font-semibold text-black hover:bg-emerald-400 transition">
                Baixar Álbum
              </button>
            </Link>

              <p className="text-xs sm:text-sm text-zinc-400">
                Download imediato após a confirmação do pagamento via Pix.
              </p>
            </div>
          </div>

          {/* Imagens da capa */}
          <div className="grid grid-cols-2 gap-4">
            {/* Capa normal */}
            <div className="relative w-full aspect-square rounded-xl overflow-hidden border border-zinc-800">
              <Image
                src="/cover.png"
                alt="Capa do álbum Reggae I Wanna"
                fill
                className="object-cover"
              />
            </div>

            {/* Capa com lista de faixas */}
            <div className="relative w-full aspect-square rounded-xl overflow-hidden border border-zinc-800">
              <Image
                src="/cover-list.png"
                alt="Tracklist do álbum Reggae I Wanna"
                fill
                className="object-cover"
              />
            </div>
          </div>
        </div>
      </MaxWidthWrapper>

      <MaxWidthWrapper>
        <div className="items-center rounded-2xl border border-zinc-800 bg-zinc-950/90 p-6 sm:p-8 shadow-xl mt-4">
          <PreSaveSection spotifyUrl="https://open.spotify.com/intl-pt/album/3YskjpOdzwM2N2hPHAMD9A?si=I-ZKJfbNR9-rK6AFUCz1Kw" />
        </div>
      </MaxWidthWrapper>

      <MaxWidthWrapper className="text-center mt-16">
        <div className="relative mx-auto flex flex-col items-center gap-10">
          <div>
            <Heading>
              <span>Registre-se grátis!</span>
              <br />
              <span className="bg-gradient-to-r from-brand-700 to-brand-800 text-transparent bg-clip-text mt-2">
                Beckasmello no seu Android
              </span>
            </Heading>
          </div>

          <div className="w-full max-w-[500px] mx-auto -mt-4">
            <div className="relative w-full aspect-[2685/409]">
              <Image
                src="/images/hitfastfx.png"
                alt="Banner Discord Insights"
                fill
                sizes="(max-width: 768px) 100vw, 500px"
                className="object-contain rounded-full"
              />
            </div>
          </div>

          <p className="text-base/7 text-gray-600 max-w-prose text-center">O melhor jeito pra monitorar seus shows.
            Obtenha notificações de <span className="font-semibold text-gray-700">mensagens, novos Freelancers ou
            qualquer outro evento
            </span>{" "}diretamente do seu Dispositivo Android.
          </p>

          <ul className="space-y-2 text-base/7 text-gray-600 text-left">
            {["Compre ingressos com segurança",
              "Venda e gerencie seus ingressos diretamente do app",
              "Cadastre-se como Músico Freelancer, Banda Show, e mais! ",
            ].map((item, index) => (
              <li key={index} className="flex gap-1.5 items-center text-left">
                <Check className="size-5 shrink-0 text-brand-700" />
                  {item}
              </li>
            ))}
          </ul>

          <div className="flex flex-col md:flex-row gap-4 w-full max-w-80 justify-center mb-4">
            <ShinyButton href="/shop" className="relative h-14 w-full text-base shadow-lg transition-shadow duration-300 hover:shadow-xl">Comprar ingresso</ShinyButton>
          </div>
        </div>
      </MaxWidthWrapper>

      <div className="flex justify-center py-6">
        <img
          src="/images/hitfastfx.png"
          alt="Banner do Festival RockBluesReggae - Baixe o App"
          className="rounded-xl shadow-lg max-w-full h-auto"
        />
      </div>

     <MaxWidthWrapper className="text-center mt-16 mb-16">
       <div className="relative mx-auto flex flex-col items-center gap-10">
         <div>
           <Heading>
             <span>Esteja entre os primeiros a usar o nosso aplicativo android!</span>
             <br />
           </Heading>
         </div>
         <p className="text-base/7 text-gray-600 max-w-prose text-center">Veja como instalar o Hitfast no seu dispositivo Android.
            Opção 1: Entre no grupo de teste fechado do Google Play <span className="font-semibold text-gray-700"> clique em
            Participar do grupo
            </span>{" "} pra poder encontrar o app no link de instalação.
         </p>

       <ul className="space-y-2 text-base/7 text-gray-600 text-left">
         {["1 ---> Entre no grupo fechado do Google Play",
           "2 ---> Instale o app em homologação no Google Play",
           "3 ---> Instalação direta sem necessidade do grupo do Google Play",
         ].map((item, index) => (
         <li key={index} className="flex gap-1.5 items-center text-left">
           <Check className="size-5 shrink-0 text-brand-700" />
             {item}
         </li>
         ))}
       </ul>

       <div className="flex flex-col md:flex-row gap-4 w-full max-w-80 justify-center mb-4">
         <ShinyButton href="https://groups.google.com/g/hitfest" className="relative h-14 w-full text-base shadow-lg transition-shadow duration-300 hover:shadow-xl">
           1
         </ShinyButton>
         <ShinyButton href="https://play.google.com/apps/testing/com.beckasmello.app" className="relative h-14 w-full text-base shadow-lg transition-shadow
         duration-300 hover:shadow-xl">
           2
         </ShinyButton>
         <ShinyButton href="https://expo.dev/accounts/beckas-lab/projects/beckasmello-mobile/builds/6e76e7da-5d91-4e19-82b8-bc0d0649fa53"
         className="relative h-14 w-full text-base shadow-lg transition-shadow duration-30">
           3
         </ShinyButton>
       </div>
      </div>
    </MaxWidthWrapper>

      {/* 4. RODAPÉ DE APOIADORES LOCAIS (Cotas Silver) */}
      <section className="w-full bg-zinc-950 py-12 border-t border-zinc-900 overflow-hidden">
        <div className="w-full text-center">
          <p className="text-zinc-500 text-xs tracking-widest uppercase mb-8">
            Marcas parceiras e apoiadores
          </p>

          {/* Mask Gradient para dar fade suave nas bordas da tela */}
          <div className="relative w-full overflow-hidden [mask-image:_linear-gradient(to_right,transparent_0,_black_64px,_black_calc(100%-64px),transparent_100%)]">
      
            {/* Container da Animação: Aumentamos a opacidade e o gap entre as logos */}
            <div className="animate-marquee flex items-center gap-10 sm:gap-16 md:gap-24 opacity-90">
        
              {/* ================= BLOCO 1 DE LOGOS ================= */}
              <Image 
                src="/images/sponsors/apoio-local1.png" 
                alt="Parceiro Local" 
                width={260} 
                height={110} 
                className="h-16 sm:h-20 md:h-24 w-auto object-contain shrink-0 grayscale hover:grayscale-0 transition duration-300" 
              />
              <Image 
                src="/images/sponsors/nubank-white.png" 
                alt="Nubank" 
                width={260} 
                height={110} 
                className="h-16 sm:h-20 md:h-24 w-auto object-contain shrink-0 grayscale hover:grayscale-0 transition duration-300" 
              />
              <Image 
                src="/images/sponsors/apoio-local4.png" 
                alt="Parceiro Local" 
                width={260} 
                height={110} 
                className="h-16 sm:h-20 md:h-24 w-auto object-contain shrink-0 grayscale hover:grayscale-0 transition duration-300" 
              />
              <Image 
                src="/images/sponsors/apoio-local5.png" 
                alt="Parceiro Local" 
                width={260} 
                height={110} 
                className="h-16 sm:h-20 md:h-24 w-auto object-contain shrink-0 grayscale hover:grayscale-0 transition duration-300" 
              />
              <Image 
                src="/images/sponsors/apoio-local7.png" 
                alt="Parceiro Local" 
                width={260} 
                height={110} 
                className="h-20 sm:h-24 md:h-28 w-auto object-contain shrink-0 grayscale hover:grayscale-0 transition duration-300" 
              />
              <Image 
                src="/images/sponsors/heineken-white.png" 
                alt="Heineken" 
                width={260} 
                height={110} 
                className="h-20 sm:h-24 md:h-28 w-auto object-contain shrink-0 grayscale hover:grayscale-0 transition duration-300" 
              />

              <Image 
                src="/images/sponsors/apoio-local1.png" 
                alt="Parceiro Local" 
                width={260} 
                height={110} 
                className="h-16 sm:h-20 md:h-24 w-auto object-contain shrink-0 grayscale hover:grayscale-0 transition duration-300" 
              />
              <Image 
                src="/images/sponsors/nubank-white.png" 
                alt="Nubank" 
                width={260} 
                height={110} 
                className="h-16 sm:h-20 md:h-24 w-auto object-contain shrink-0 grayscale hover:grayscale-0 transition duration-300" 
              />
              <Image 
                src="/images/sponsors/apoio-local4.png" 
                alt="Parceiro Local" 
                width={260} 
                height={110} 
                className="h-16 sm:h-20 md:h-24 w-auto object-contain shrink-0 grayscale hover:grayscale-0 transition duration-300" 
              />
              <Image 
                src="/images/sponsors/apoio-local5.png" 
                alt="Parceiro Local" 
                width={260} 
                height={110} 
                className="h-16 sm:h-20 md:h-24 w-auto object-contain shrink-0 grayscale hover:grayscale-0 transition duration-300" 
              />
              <Image 
                src="/images/sponsors/apoio-local7.png" 
                alt="Parceiro Local" 
                width={260} 
                height={110} 
                className="h-20 sm:h-24 md:h-28 w-auto object-contain shrink-0 grayscale hover:grayscale-0 transition duration-300" 
              />
              <Image 
                src="/images/sponsors/heineken-white.png" 
                alt="Heineken" 
                width={260} 
                height={110} 
                className="h-20 sm:h-24 md:h-28 w-auto object-contain shrink-0 grayscale hover:grayscale-0 transition duration-300" 
              />  
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

